import { useMemo } from 'react';
import { UserService } from '../Services/UserService';
import useConfiguration from './UseConfiguration';
import useAuthenticatedFetchClient from './UseAuthenticatedFetchClient';
export default function useUserService() {
    const configuration = useConfiguration();
    const fetchClient = useAuthenticatedFetchClient();
    const userService = useMemo(() => new UserService(fetchClient, configuration.serviceConfig), [fetchClient, configuration.serviceConfig]);
    return userService;
}
//# sourceMappingURL=UseUserService.js.map